import { viewLabel, categoriesText } from '@fsv/core';
import { Link } from 'react-router-dom';
import { useTenantPath, useDamageRef } from '../data/hooks';
import type { Damage } from '@fsv/data';
import { formatRelative } from '@fsv/data';
import { Icon } from './Icon';
import { StatusBadge } from './Status';
import './DamageRow.css';

/** One damage in a list: thumbnail, number, status, title, where and when. */
export function DamageRow({
  damage,
  showAircraft = true,
  to,
  onSelect,
  selected = false,
  extra,
}: {
  damage: Damage;
  showAircraft?: boolean;
  to?: string;
  onSelect?: () => void;
  selected?: boolean;
  extra?: React.ReactNode;
}) {
  const ref = useDamageRef();
  const path = useTenantPath();
  const body = (
    <>
      <span className="drow__thumb">
        {damage.thumbUrl ? <img src={damage.thumbUrl} alt="" loading="lazy" /> : <Icon name="image" size={20} />}
      </span>
      <span className="drow__main">
        <span className="drow__top">
          <span className="mono drow__num">{ref(damage.number)}</span>
          <StatusBadge status={damage.status} />
        </span>
        <span className="drow__title">{damage.title}</span>
        <span className="drow__meta">
          {showAircraft && <span className="mono">{damage.registration}</span>}
          <span>{viewLabel[damage.view]}</span>
          <span>{categoriesText(damage.categories)}</span>
          <span>{formatRelative(damage.reportedAt, new Date())}</span>
          {damage.imageCount > 0 && (
            <span className="drow__photos">
              <Icon name="camera" size={14} />
              {damage.imageCount}
            </span>
          )}
        </span>
        {extra}
      </span>
    </>
  );
  const cls = `drow st--${damage.status}${selected ? ' is-selected' : ''}`;
  if (onSelect) {
    return (
      <button type="button" className={cls} onClick={onSelect} aria-current={selected || undefined}>
        {body}
      </button>
    );
  }
  return (
    <Link className={cls} to={to ?? path(`/schaden/${damage.id}`)}>
      {body}
    </Link>
  );
}
